import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { RouteReuseService } from '../servicesNavegacion/router.service';

@Injectable({
    providedIn: 'root' // Esto asegura que el servicio esté disponible en toda la aplicación
})
export class CustomReuseStrategy implements RouteReuseStrategy {
    handlers: { [key: string]: DetachedRouteHandle } = {};

    constructor(private routeReuseService: RouteReuseService) { }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === curr.routeConfig;
    }

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        return this.routeReuseService.getReuseRoutes() && (route.data.shouldReuse || false);
    }

    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
        const path = this.replaceParams(route.routeConfig.path, route.params);
        if (this.routeReuseService.getReuseRoutes() && route.data.shouldReuse) {
            this.handlers[path] = handle;
        }
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        const path = this.replaceParams(route.routeConfig.path, route.params);
        return this.routeReuseService.getReuseRoutes() && !!this.handlers[path];
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
        const path = this.replaceParams(route.routeConfig.path, route.params);
        return this.handlers[path];
    }

    private replaceParams(path: string, params: any = {}) {
        const keys = Object.keys(params);

        keys.forEach((key: string) => {
            const reg = new RegExp(`:${key}`);
            path = path.replace(reg, params[key]);
        });

        return path;
    }
}



// import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
// import * as $ from 'jquery';

// export class CustomReuseStrategy implements RouteReuseStrategy {

//     handlers: { [key: string]: DetachedRouteHandle } = {};

//     /**
//      * Se ejecuta cada vez que cambia una ruta, determina si se reutilizará la ruta, si el método retorna TRUE
//      * los demas métodos no seran ejecutados, pero si retorna FALSE los demas métodos seran ejecutados.
//      */
//     shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
//         return future.routeConfig === curr.routeConfig;
//     }

//     /**
//     * Cuando se sale de un ruta se llama a este método el cual si devuelve TRUE se ejecutara el método store()
//     * */

//     shouldDetach(route: ActivatedRouteSnapshot): boolean {
//         return route.data.shouldReuse || false;
//     }

//     /**
//     *   En este método realizamos el guardado de las instancias de las rutas que queremos reutilizar
//     * */

//     store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
//         const path = this.replaceParams(route.routeConfig.path, route.params);
//         if (route.data.shouldReuse) {
//             this.handlers[path] = handle;
//         }
//     }

//     /**
//     * Si ingresamos a una ruta este método se ejecutará y si devuelve TRUE se ejecutara el método retrieve()
//     * */

//     shouldAttach(route: ActivatedRouteSnapshot): boolean {
//         const path = this.replaceParams(route.routeConfig.path, route.params);
//         return !!this.handlers[path];
//     }

//     /**
//     *  Este método retornaria la instancia de la ruta guardada anteriormente, si la instancia no fue guardada retornara un valor NULL
//     * */

//     retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
//         const path = this.replaceParams(route.routeConfig.path, route.params);
//         return this.handlers[path];
//     }

//     private replaceParams(path: string, params: any = {}) {
//         const keys = Object.keys(params);

//         keys.forEach((key: string) => {
//             const reg = new RegExp(`:${key}`);
//             path = path.replace(reg, params[key]);
//         });

//         return path;
//     }
// }